import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { FacilityInvitationPdfsApi } from '../../../apis/InvitationApi/FacilityInvitationPdfsApi.ts';

export function useGetFacilityInvitationPdfs(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.facilityInvitationPdfs, facilityId],
        queryFn: () => FacilityInvitationPdfsApi.getByFacility(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
